<template>
  <v-card>
    <v-form ref="form">
      <v-card-title> Confirm Party Details </v-card-title>
      <party-details
        :party="firstParty"
        label="First Party"
        data-testid="firstParty"
        @update="updateFirstParty"
      />
      <party-details
        v-for="(counterParty, index) in counterParties"
        :key="counterParty.id"
        :party="counterParty"
        :label="`Counter Party ${index + 1}`"
        :data-testid="`counterParty${index + 1}`"
        @update="updateCounterParty(index, $event)"
      />
    </v-form>
  </v-card>
</template>

<script>
import PartyDetails from './PartyDetails.vue'
export default {
  name: 'ConfirmPartyDetails',
  components: { PartyDetails },
  props: {
    documentRef: {
      type: Object,
      required: true
    },
    document: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {}
  },
  computed: {
    firstParty() {
      return this.document.firstParty
    },
    counterParties() {
      return this.document.counterParties
    }
  },
  beforeUpdate() {
    this.checkError()
  },
  methods: {
    checkError() {
      this.$emit('hasError', this.hasError())
    },
    hasError() {
      return !this.$refs.form.validate()
    },
    async updateFirstParty(party) {
      await this.updateDocument({
        firstParty: party
      })
    },
    async updateCounterParty(index, party) {
      const counterParties = this.counterParties
      counterParties[index] = party
      await this.updateDocument({
        counterParties
      })
    },
    async updateDocument(data) {
      this.$emit('saving')
      await this.documentRef.update(data)
      this.$emit('saved')
      this.checkError()
    }
  }
}
</script>
